module.exports = __webpack_public_path__ + "static/img/znzzhome.0423f05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzzhome.jpg
// module id = NHWc
// module chunks = 0